import { createSlice } from '@reduxjs/toolkit';

const initialState = null;

export const safalMyBuySlice = createSlice({
  name: 'safalMyBuySlice',
  initialState,
  reducers: {
    setSafalMyBuyState: (state, action) => {
      state = action.payload;
      return state;
    },
    resetSafalMyBuyState: () => {
      return initialState;
    },
  },
});

export const { setSafalMyBuyState, resetSafalMyBuyState } = safalMyBuySlice.actions;

export default safalMyBuySlice.reducer;
